import { Icon } from "@utils/helper";
import { useDispatch } from "noval";

const LogoutButton = ({ t }) => {
  const { dispatch, addState } = useDispatch();
  return (
    <div
      onClick={() => {
        addState({ openDrawer: false });
        dispatch({ logoutOpen: true }, "modals");
      }}
      className="flex items-center cursor-pointer gap-4 ltr:pl-[52px] rtl:pr-[52px]"
    >
      <Icon id="r4-c14" />
      <h1 className="font-normal text-base">{t("slide.log_out")}</h1>
    </div>
  );
};

export default LogoutButton;
